export const rawData = [
  { date: "May 27", minutes: 45, calls: 12, cost: 2.15 },
  { date: "May 28", minutes: 62, calls: 18, cost: 3.02 },
  { date: "May 29", minutes: 80, calls: 24, cost: 4.10 },
  { date: "May 30", minutes: 105, calls: 30, cost: 5.35 },
  { date: "May 31", minutes: 140, calls: 38, cost: 7.12 },
  { date: "Jun 1", minutes: 190, calls: 52, cost: 9.84 },
  { date: "Jun 2", minutes: 250, calls: 68, cost: 12.76 },
];

export const GROUP_OPTIONS = [
  "Daily",
  "Weekly",
  "Monthly",
];

export const METRIC_OPTIONS = [
  "Minutes",
  "Calls",
  "Cost",
];